export const POST_PURCHASE_GST_REPORT_API = 'POST_PURCHASE_GST_REPORT_API'
export const POST_PURCHASE_GST_REPORT_API_SUCCESS = 'POST_PURCHASE_GST_REPORT_API_SUCCESS'
export const POST_PURCHASE_GST_REPORT_API_ERROR_ACTION = 'POST_PURCHASE_GST_REPORT_API_ERROR_ACTION'


